module.exports = __webpack_public_path__ + "static/images/release-spots-time.02ba9536001bf32a5d80f58f5909d429.svg";